module.exports = "<nv-react-component component=\"CohortAnalytics\"></nv-react-component>";